import GenericDropdown from '../../generic/genericDropdown'
import Link from '@mui/material/Link'
import { backendDeleteWithoutRefresh } from '../../../helpers/callBackend'
import { errorMessage } from '../../../helpers/errorMessageFunc'

const CustomReportsTableDropDown = ({ rowData, onDelete }) => {
  const handleDelete = async () => {
    try {
      const deleteResp = await backendDeleteWithoutRefresh('/api/reports/v2/', {
        report_builder_id: rowData.id,
      })
      if (deleteResp.status !== 204) {
        throw new Error(`Delete returned unexpected status: ${deleteResp.status_code}`)
      }
      onDelete(rowData)
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const dropdownItems = [
    <Link href={`/reports-custom/editing/details/000${rowData?.id}`} underline='none'>
      Edit
    </Link>,
    <Link component='button' underline='none' color='red' onClick={handleDelete}>
      Delete
    </Link>,
  ]

  return <GenericDropdown dropdownItems={dropdownItems} />
}

export default CustomReportsTableDropDown
